import axios from "axios";
import { UserAchievements } from "./types";
import { API_BASE_URL } from "@/libs/apis/commons";
import { QueryClient } from "@tanstack/react-query";
import { USER_ACHIEVEMENTS } from "@/libs/apis/onboarding/reactQueryCacheKeys";
import { logger } from "@/libs/utils";

export const getUserAchievementsApi = async (swooshHandle: string) => {
  return await axios
    .get(`${API_BASE_URL}/users/${swooshHandle}/achievements`)
    .then(({ data }: { data: UserAchievements }) => data);
};

export const prefetchUserAchievementData = async (
  queryClient: QueryClient,
  swooshHandle: string,
) => {
  return await queryClient.prefetchQuery(
    [USER_ACHIEVEMENTS, swooshHandle],
    async () =>
      await getUserAchievementsApi(swooshHandle).catch((e) => {
        logger.debug(e);
        return {};
      }),
    { retry: false },
  );
};
